import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Site Content API
export const siteContentAPI = {
  get: () => axios.get(`${API_URL}/site-content`),
  update: (data) => axios.put(`${API_URL}/site-content`, data)
};

// Portfolio Items API
export const portfolioItemsAPI = {
  getAll: () => axios.get(`${API_URL}/portfolio-items`),
  getByCategory: (category) => axios.get(`${API_URL}/portfolio-items/category/${category}`),
  getById: (id) => axios.get(`${API_URL}/portfolio-items/${id}`),
  create: (data) => axios.post(`${API_URL}/portfolio-items`, data),
  update: (id, data) => axios.put(`${API_URL}/portfolio-items/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/portfolio-items/${id}`)
};

// Keep existing APIs
export { filmsAPI, uploadAPI } from './api';
